import React, { useState } from 'react';
import { Modal, Space, Row, Col, Avatar, List, Divider } from 'antd';
import './DeliveryList.less';
import {Project} from '../model'
import UserIcon from '@/components/UserIcon/UserIcon'; 
import DeliveryDetail from '@/delivery-detail/DeliveryDetail';
import { Delivery } from '@/delivery/model';
import { DateUtil } from '@/utils/DateUtil';
 
interface DeliveryProps {
    project: Project;
    visible: boolean;
    onClose: () => void; 
}

const DeliveryList: React.FC<DeliveryProps> = ({  visible, onClose, project }) => { 

    const [delivery, setDelivery] = useState<Delivery>(null)
    const [deliveryVisible, setDeliveryVisible] = useState<boolean>(false)

    if(!project || !project.deliveries){
        return '';
    }
    const sortedData = [...project.deliveries].sort((a, b) => DateUtil.getDateFromTimeString(b.createTime).getTime() - DateUtil.getDateFromTimeString(a.createTime).getTime());
    
    const showDelivery = (targetDeelivery)=>{
        setDelivery(targetDeelivery);
        setDeliveryVisible(true);
    }
    
    return (
        <> 
            <Modal 
                visible={visible}
                onCancel={onClose} 
                title={`${project.name}所关联的交付项`}
                footer={null}
                width="1000px"
                centered
                style={{ top: 0 }}
                bodyStyle={{ height: '80vh', overflowY: 'auto', padding: 0 }}
            >
                <List
                    dataSource={sortedData}
                    style={{margin:'auto', maxWidth:'90%', minWidth:'80%'}}
                    renderItem={item => (
                        <List.Item onClick={()=>showDelivery(item)}>
                            <Row className="delivery-item" style={{ width: '100%' }}>
                                <Col span={12}>
                                    <Space direction="horizontal">
                                        <div>{item.finishDate? DateUtil.getDateFromDateString(item.finishDate).toLocaleDateString() : ''}</div>
                                        <div>{item.name}</div>
                                        <div>{item.taskStatusName}</div>
                                    </Space>
                                </Col>
                                <Col span={12} style={{ textAlign: 'right' }}>
                                    <Space>
                                        <div className='proposal-member'>
                                            {/* <span>提报人：</span> */}
                                            <UserIcon effect="post" id={item.submitterId+""}></UserIcon>
                                        </div>
                                        <Divider type="vertical" style={{ marginTop: '2px', alignSelf: 'center' }} />
                                        <div className='execute-member'>
                                            {/* <span>跟进人：</span> */}
                                            <Space size={0}>
                                                {item.members.map((item, index) => (
                                                    <UserIcon effect={index == 0 ? 'leader' : null} id={item+""} key={index}></UserIcon>
                                                ))}  
                                            </Space>
                                        </div> 
                                    </Space>
                                </Col>
                            </Row>
                        </List.Item>
                    )}
                />
                
            </Modal>
            {/* <TestModal visible={deliveryVisible} close={()=>setDeliveryVisible(false)} /> */}
            <DeliveryDetail visible={deliveryVisible} delivery={delivery} mode={0} close={()=>setDeliveryVisible(false)}/>
        </>
    );
};

export default DeliveryList;

/*

帮我写一个弹框，要求如下：
1. 使用react+Ant-D的Model组件实现。
2. 布局尽量使用<Space />，<Row>，<Col>或者其他Ant-D组件，尽量不使用<div>
3. 弹框打开后满屏。
4. 每一行的数据结构如下：
```
export class DeliveryBrief{
    id:SNumber;
    title:SString;
    finishTime:Date;
    submitTime:Date;
    submitterId:SNumber;
    members:SNumber [];//队长排第一个
    status:SNumber;//0-未完成 1-已完成
}
```
每一行从左到右的展示字段分为2组：finishTime、title、status为第一组，居左； submitter的头像、members的头像（半叠加成一行）为一组，整体靠右。
5. 行没有边框，背景色为：#effffc，当鼠标hover的时候，背景色为：#c0fff1。
6. 整个列表按照finishTime倒序排序。
7. 逻辑代码写到Delivery.tsx中，样式代码写到Delivery.less中。

*/